export const FLAG_SHOP_ONLINE_VIDEOS = "shop-online-videos"
export const FLAG_ZITADEL_CREDENTIALS_LOGIN = "zitadel-credentials-login"
export const FLAG_ZITADEL_AZURE_LOGIN = "zitadel-azure-login"